import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CtaFormComponent} from './cta-form.component';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MediaModule} from '@spartacus/storefront';

import {A11yModule} from '@angular/cdk/a11y';
import {FormlyDatePickerModule} from '../../shared/formly/fields/duration/date-picker/formly-date-picker.module';
import {RECAPTCHA_BASE_URL, RecaptchaModule} from 'ng-recaptcha';

import {DcpDateFormatter} from '@dcp/configurator';
import {CtaWebcomponentWrapperComponent} from '@app/product/cta-form/cta-webcomponent-wrapper/cta-webcomponent-wrapper.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    FormsModule,
    MediaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductCallToActionComponent: {
          component: CtaFormComponent,
        },
      },
    }),
    A11yModule,
    FormlyDatePickerModule,
    ReactiveFormsModule,
    DcpDateFormatter,
    RecaptchaModule,
    CtaFormComponent,
    CtaWebcomponentWrapperComponent,
  ],
  exports: [CtaFormComponent],
  providers: [
    {
      provide: RECAPTCHA_BASE_URL,
      useValue: 'https://recaptcha.net/recaptcha/api.js',
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CtaFormModule {}
